module.exports = __webpack_public_path__ + "logo.a961dfbf36f110092c3f.png";


//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/src/img/logo.png
// module id = ../../../../../src/img/logo.png
// module chunks = styles